<script setup>
import KdContainer from "./kdContainer.vue";
import KdTempSolutionForm from "@/components/kdAuditForm/kdTempSolutionForm.vue";
</script>

<template>
  <kd-container>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="128px">
      <el-form-item label="根因分析" prop="reasonAnalyst">
        <el-input
          :disabled="receivedForm && receivedForm.reasonAnalyst !== ''"
          placeholder="请输入根因分析"
          v-model="form.reasonAnalyst"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 4 }"
          maxlength="500"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item>
        <file-upload-list
          v-if="receivedForm && receivedForm.file !== undefined"
          ref="fileUploadList"
          :fileList="form.file"
        ></file-upload-list>
        <drag-upload
          v-else
          ref="uploadFile"
          :accessoryList.sync="form.file"
          :httpRequest="imAction"
        />
      </el-form-item>


      <div v-if="this.taskDefKey == 'Activity_0nw86wc' ||
      this.taskDefKey == 'Activity_160anpw' ||
      this.taskDefKey == 'Activity_1348h5u' ||
      this.taskDefKey == 'Activity_1a7qzv5' ||
      this.taskDefKey == 'Activity_0g2kdpo'">
          <el-form-item label="临时措施" prop="provisionalMeasures">
            <el-input v-model="form.provisionalMeasures" type="textarea" placeholder="请输入临时措施" disabled :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
        </div>
        <div v-else>
          <kd-temp-solution-form
            :provisionalMeasuresProp.sync="form.provisionalMeasures"
          ></kd-temp-solution-form>
        </div>
<!--      <el-form-item label="临时措施图片" prop="provisionalMeasuresFile">-->
<!--        <drag-upload-->
<!--          ref="uploadFile"-->
<!--          :accessoryList.sync="form.provisionalMeasuresFile"-->
<!--          :httpRequest="imAction"-->
<!--          accept="jpg, png, jpeg, svg"-->
<!--          :tipStatus="false"-->
<!--        />-->
<!--        <p style="font-size:12px;line-height:1.5;color:#999;margin:2px 0">-->
<!--          仅能上传图片，支持格式：JPG、PNG、JPEG、SVG格式，单张图片不超过500M-->
<!--        </p>-->
<!--      </el-form-item>-->

      <el-form-item label="永久方案" prop="permanentSolution">
        <el-input
          v-model="form.permanentSolution"
          type="textarea"
          placeholder="请输入永久方案"
          :autosize="{ minRows: 4, maxRows: 4 }"
          maxlength="500"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="永久方案附件" prop="permanentSolutionFile">
        <drag-upload
          ref="uploadFile"
          :accessoryList.sync="form.permanentSolutionFile"
          :httpRequest="imAction"
        />
      </el-form-item>
      <el-form-item label="计划断点时间" prop="planBreakpointTime">
        <el-date-picker
          v-model="form.planBreakpointTime"
          type="date"
          placeholder="请选择计划断点时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button class="lang-but" type="primary" @click="auditPassBtClick"
          >确定</el-button
        >
      </el-form-item>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog
        width="600px !important"
        title="审核驳回"
        :visible.sync="dialogVisible"
      >
        <el-form
          :model="form"
          :rules="rules"
          ref="rejectFormRef"
          label-width="85px"
        >
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input
              v-model="form.rejectReason"
              type="textarea"
              placeholder="请输入驳回原因"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()"
              >提交</el-button
            >
            <el-button plain @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>

<style scoped lang="scss"></style>
<script>
import { baseURL } from "../../util/url";
import { requestSubmitAuditKD } from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

/**
 * 14.2-责任单位填写永久方案和计划改善时间
 */
export default {
  name: "kdAccountUnitWritePermanentSolutionAudit",
  components: { KdAuditPassDialog },
  props: {
    taskId: String,
    questionId: String,
    taskDefKey: String,
    receivedForm: {
      type: Object,
      default: () => ({
        hasReasonAnalystMaterial: 0,
        reasonAnalystMaterial: "",
        reasonAnalyst: "",
        requestCompletionProcess: "",
        file: undefined,
      }),
    },
  },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token"),
      },
      hasFileEchoShow: false,
      imAction: "/manage/staff/upload?fileType=auditResource",
      dialogVisible: false,
      auditPassDialogVisible: false,
      form: {
        provisionalMeasures: "",
        userId: "",
        reasonAnalystMaterial: "",
        reasonAnalyst: "",
        permanentSolution: "",
        permanentSolutionFile: [],
        // provisionalMeasuresFile: [],
        planBreakpointTime: "",
        requestCompletionProcess: "",
        file: [],
        rejectReason: "",
        auditText: "",
      },
      rules: {
        reasonAnalyst: [
          {
            required: true,
            message: "根因分析不能为空",
            trigger: ["blur", "change"],
          },
        ],
        // provisionalMeasuresFile: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (!value || value.length === 0) {
        //         callback(new Error("临时措施图片不能为空"));
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: "change",
        //   },
        // ],
        permanentSolution: [
          {
            required: true,
            message: "永久方案不能为空",
            trigger: ["blur", "change"],
          },
        ],
        planBreakpointTime: [
          {
            required: true,
            message: "计划断点时间不能为空",
            trigger: ["blur", "change"],
          },
        ],
        rejectReason: [
          {
            required: true,
            message: "驳回原因不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    },
  },
  methods: {
    auditPassBtClick() {
      this.$refs["formRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        this.auditPassDialogVisible = true;
      });
    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        reasonAnalystData: this.form,
        variables: {
          approval: true,
        },
      };
      // const today = new Date();
      // today.setHours(23, 59, 59, 0);
      // if (this.form.planBreakpointTime && this.form.planBreakpointTime > today) {
      //   this.$DonMessage.error("实际断点时间不能超过今天！");
      //   return;
      // }
      requestSubmitAuditKD(formData).then((res) => {
        if (res.status == "0") {
          this.$DonMessage.success("审批通过!");
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      });
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      });
    },
    auditRejectSubmit() {
      this.$refs["rejectFormRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: false,
          },
        };
        requestSubmitAuditKD(formData).then((res) => {
          if (res.status == "0") {
            this.$DonMessage.success("驳回成功!");
            this.backRouterPath();
            this.dialogVisible = false;
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });
    },
  },
  mounted() {
    if (this.receivedForm) {
      this.form.reasonAnalyst = this.receivedForm.reasonAnalyst ?? "";
      this.form.provisionalMeasures = this.receivedForm.provisionalMeasures ?? "";
      this.form.reasonAnalystMaterial =
        this.receivedForm.reasonAnalystMaterial ?? "";
      this.form.requestCompletionProcess = this.receivedForm
        .requestCompletionProcess
        ? this.receivedForm.requestCompletionProcess
        : 0;
      this.form.file = this.receivedForm.file ? this.receivedForm.file : [];
      this.form.userId = this.receivedForm.userId ?? "";
      this.hasFileEchoShow = this.form.file.length > 0;
    }
  },
};
</script>
